require('./brokerHireAlternativeInvestmentFund.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const { BrokerHireAlternativeInvestmentFundStep1 } = require('../brokerHireAlternativeInvestmentFundStep1/brokerHireAlternativeInvestmentFundStep1');
const { BrokerHireAlternativeInvestmentFundStep2 } = require('../brokerHireAlternativeInvestmentFundStep2/brokerHireAlternativeInvestmentFundStep2');
const BrokerHireAlternativeInvestmentFundSuccess = require('../brokerHireAlternativeInvestmentFundSuccess/brokerHireAlternativeInvestmentFundSuccess');
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ constants
const { catalogue, analyticsId } = require('../analytics/brokerHireAlternativeInvestmentFund.tracking');

class BrokerHireAlternativeInvestmentFund extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.state = {
            existExtantData: false,
        }
    }

    componentWillReceiveProps(newProps) {
        const { immInvestmentFunds, onFinish } = newProps;
        const finished = immInvestmentFunds.get('submitSuccessful');
        const visibleStepValid = immInvestmentFunds.getIn(['steps', 1, 'valid']);

        if (__CONTACT_CENTER__ && visibleStepValid && !finished) {
            onFinish();
        }
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    buildContent() {
        let content;

        if (this.props.immInvestmentFunds && !this.props.immInvestmentFunds.get('submitSuccessful')) {
            content = this.buildWizard();
        } else {
            content = (
                <BrokerHireAlternativeInvestmentFundSuccess
                    immSubscription={this.props.immInvestmentFunds}
                    immInvestmentFunds={this.props.immInvestmentFunds}
                    immAccounts={this.props.immAccounts}
                />
            );
        }

        return content;
    }

    buildWizard() {
        const {
            accountSelected,
            fundId,
            immAccounts,
            immBlockedAccountsIds,
            immBrokerMyInvestments,
            immInvestmentFunds,
            immFlagBasedFeatures,
            isBlockedAccountsLoading,
            validateStep,
            setVisibleStep,
            setWillCancel,
        } = this.props;

        const immSteps = immInvestmentFunds.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immInvestmentFunds.get('visibleStep');
        const isFetching = immInvestmentFunds.get('isFetching');
        const wizardClass = 'hire-alternative-investment__wizard';
        const immFinalButton = 'broker-hireInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const titleHeaderMenuWizard = formatText(`brokerAlternativeFundsBuy-mainTitle`);
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: []
        };
        const contractNumberSelected = immAccounts.getIn([accountSelected, 'contractNumber']);
        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);
        const immFundSelected = immBrokerMyInvestments
            .getIn(['products', 'alternativeFunds', 'stocks']).filter( fund => fund.get('associatedAccountContractNumber') === contractNumberSelected )
            .find( fundSel => fundSel.get('customInstitutionSecurityId') ===  fundId && fundSel.get('isin') ===  isin)
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;

        const tealiumData = [
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_VIEW]({ productName: isin }),
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_2_VIEW]({ productName: isin }),
            catalogue[analyticsId.BROKER_HIRE_INVESTMENT_FUND_STEP_1_SUCCESS](),
        ];

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    isLoading={isFetching}
                    nextButtonDisabled={linkedToRobo}
                >
                    <BrokerHireAlternativeInvestmentFundStep1
                        immAccounts={this.props.immAccounts}
                        immInvestmentFunds={this.props.immInvestmentFunds}
                        immBlockedAccountsIds={immBlockedAccountsIds}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        onChangeContract={this.props.handleChangeContract}
                        accountSelected={accountSelected}
                        onAccountChange={this.props.handleAccountChange}
                        onSetAmount={this.props.handleSetAmount}
                        onReadCheckedStep1={this.props.onReadCheckedStep1}
                        setIntervenerName={this.props.setIntervenerName}
                        setIntervenerType={this.props.setIntervenerType}
                        addIntervener={this.props.addIntervener}
                        removeIntervener={this.props.removeIntervener}
                        restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                        isBlockedAccountsLoading={isBlockedAccountsLoading}
                        setIsSubscription={this.props.setIsSubscription}
                        setIsNewContract={this.props.setIsNewContract}
                        validateSchema={this.props.validateSchema}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        onStepChange={this.props.onStepChange}
                        tealiumData={[tealiumData[0]]}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <BrokerHireAlternativeInvestmentFundStep2
                        immInvestmentFunds={this.props.immInvestmentFunds}
                        immAccounts={this.props.immAccounts}
                        fundId={fundId}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        onStepChange={this.props.onStepChange}
                        tealiumData={[tealiumData[1], tealiumData[2]]}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        return this.buildContent();
    }
}

BrokerHireAlternativeInvestmentFund.propTypes = {
    fundId: PropTypes.string,
    immBlockedAccountsIds: PropTypes.object,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    immInvestmentFunds: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    isBlockedAccountsLoading: PropTypes.bool.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    accountSelected: PropTypes.string,
    handleAccountChange: PropTypes.func.isRequired,
    handleSetAmount: PropTypes.func.isRequired,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    onReadCheckedStep1: PropTypes.func.isRequired,
    handleChangeContract: PropTypes.func,
    setIsSubscription: PropTypes.func,
    setIsNewContract: PropTypes.func,
    validateSchema: PropTypes.func,
    extantDataFetch: PropTypes.func,
    onStepChange: PropTypes.func,
};

module.exports = BrokerHireAlternativeInvestmentFund;
